// import React, { useState, useEffect } from "react";
// import styled from "styled-components";
// import Button from "react-bootstrap/Button";
// import Modal from "react-bootstrap/Modal";
// import avtar2 from "../../../assests/emotions2.svg";
// import { useNavigate } from "react-router-dom";
// import logo from "../../../assests/Daalchini-logo.svg";
// import Avtar from "../../../assests/Avatar.png";
// import "./style.css";
// import { Link } from "react-router-dom";
// import SubMenu from "../Sidebar/SidebarItem";
// import { SidebarData } from "./SidebarData";
// import { useParams } from "react-router-dom";

// export default function Sidebar(data, props) {
//   let navigate = useNavigate();
//   const { userid } = useParams();
//   const handleClose = () => setShow(false);
//   const [show, setShow] = useState(false);
//   const [openKeys, setOpenKeys] = useState([""]);
//   const [sidebar, setSidebar] = useState(false);

//   const showSidebar = () => setSidebar(!sidebar);
//   const Nav = styled.div`
//     height: 80px;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//   `;

//   const NavIcon = styled(Link)`
//     margin-left: 2rem;
//     font-size: 2rem;
//     height: 80px;
//     display: flex;
//     justify-content: flex-start;
//     align-items: center;
//   `;

//   const SidebarNav = styled.nav`
//     margin-top: -80px;
//     width: 250px;
//     height: 60vh;
//     display: flex;
//     justify-content: center;
//     margin:auto,
   
   
//     left: ${({ sidebar }) => (sidebar ? "0" : "-100%")};
//     transition: 350ms;
//     z-index: 10;
//   `;

//   const SidebarWrap = styled.div`
//     width: 100%;
//   `;

//   // const logout = () => {
//   //   console.log("hello");
//   //   localStorage.removeItem("data");
//   //   localStorage.removeItem("allPermissions");

//   //   // history.push('/')
//   //   navigate("/");
//   // };
//   const logout = () => {
//     localStorage.removeItem("allPermissions");
//     localStorage.removeItem("data");

//     window.location.href = "/";
//   };

//   const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

//   const handleCloseDropdown = () => {
//     setOpenDropdownIndex(null);
//   };

//   const viewProfile = () => {
//     navigate(`/userlist/${195}`);
//   };
//   return (
//     <>
//       <div className="side-div1">
//         <div className="sidebar">
//           <div className="">
//             <div className="logo-div">
//               <img src={logo} alt="" />
//             </div>
//             <div className="main-profile">
//               {/* <div className="profileDiv">
//                 <img src={Avtar} alt="" />
//                {
//                  <div className="designation">
//                  <p style={{textTransform:"capitalize"}}>{localStorage.data ? JSON.parse(localStorage.data).details.userDetails.full_name : 'N/A'}</p>
//                  <span>{localStorage.data ? JSON.parse(localStorage.data).details.userRole.role_name : 'N/A'}</span>
//                </div>
//                }
               
              
//               </div> */}
//               <div className="profileDiv">
//                 <img src={Avtar} alt="" />
//                 {localStorage.data && (
//                   <div className="designation">
//                     <span className="userNameClass" >
//                       {
//                         JSON.parse(localStorage.data).details.userDetails
//                           .full_name
//                       }
//                     </span>
//                     <span>
//                       {JSON.parse(localStorage.data).details.userRole.role_name}
//                     </span>
                  
//                   </div>
//                 )}
//               </div>
//               <div className="view-profile">
//                 <Link
//                   to={`/users/userlist/${
//                     localStorage.data
//                       ? JSON.parse(localStorage.data).details.userDetails.id
//                       : "N/A"
//                   }`}
//                 >
//                   <div
//                     style={{ border: "0.1px solid #ccc", marginTop: "30px", }}
//                   >
//                     <button className="viewBtn">View Profile</button>
//                   </div>
//                 </Link>
//               </div>
//             </div>
//           </div>

//           <div >
           
//             {SidebarData.map((item) => (
//               <SubMenu
//                 key={item.title}
//                 item={item}
//                 openDropdownIndex={openDropdownIndex}
//                 setOpenDropdownIndex={setOpenDropdownIndex}
//                 handleCloseDropdown={handleCloseDropdown}
//               />
//             ))}
//           </div>
//         </div>
//         <div>
//           <div className="logoutOutter">
//             <Button
//               style={{
//                 padding: "1vh 3vw",
//                 backgroundColor: "#fff",
//                 fontSize: "1vw",
//                 color: "black",
//               }}
//               variant="outline-danger"
//               size="lg"
//               onClick={() => setShow(true)}
//             >
//               Logout
//             </Button>
//           </div>
//         </div>

//         <Modal
         
//           show={show}
//           onHide={() => setShow(false)}
//         >
//          <div className="logout-popup">
//   <div className="logout-popup-header">
//     <img className="logout-popup-image" src={avtar2} alt="Logout Illustration" />
//   </div>

//   <div className="logout-popup-content">
//     <p className="logout-popup-title">Log Out</p>
//     <span className="logout-popup-message">Are you sure you want to log out?</span>
//   </div>

//   <div className="logout-popup-buttons">
//     <Button className="logout-popup-cancel" onClick={handleClose}>
//       Cancel
//     </Button>
//     <Button className="logout-popup-confirm" onClick={logout}>
//       Yes, Logout
//     </Button>
//   </div>
// </div>
//         </Modal>
//       </div>
//     </>
//   );
// }

// import React, { useState, useEffect } from "react";
// import styled from "styled-components";
// import Button from "react-bootstrap/Button";
// import Modal from "react-bootstrap/Modal";
// import avtar2 from "../../../assests/emotions2.svg";
// import { useNavigate } from "react-router-dom";
// import logo from "../../../assests/Daalchini-logo.svg";
// import Avtar from "../../../assests/Avatar.png";
// import "./style.css";
// import { Link } from "react-router-dom";
// import SubMenu from "../Sidebar/SidebarItem";
// import { SidebarData } from "./SidebarData";
// import { useParams } from "react-router-dom";
// import { logoutuser } from "../../../HandleAPICalls/actions";

// export default function Sidebar(data, props) {
//   let navigate = useNavigate();
//   const { userid } = useParams();
//   const handleClose = () => setShow(false);
//   const [show, setShow] = useState(false);
//   const [openKeys, setOpenKeys] = useState([""]);
//   const [sidebar, setSidebar] = useState(false);

//   const showSidebar = () => setSidebar(!sidebar);
//   const Nav = styled.div`
//     height: 80px;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//   `;

//   const NavIcon = styled(Link)`
//     margin-left: 2rem;
//     font-size: 2rem;
//     height: 80px;
//     display: flex;
//     justify-content: flex-start;
//     align-items: center;
//   `;

//   const SidebarNav = styled.nav`
//     margin-top: -80px;
//     width: 250px;
//     height: 60vh;
//     display: flex;
//     justify-content: center;
//     margin: auto,
   
//     left: ${({ sidebar }) => (sidebar ? "0" : "-100%")};
//     transition: 350ms;
//     z-index: 10;
//   `;

//   const SidebarWrap = styled.div`
//     width: 100%;
//   `;

//   const logout = () => {
//     localStorage.removeItem("allPermissions");
//     localStorage.removeItem("data");
//     window.location.href = "/";
//   };

//   const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

//   const handleCloseDropdown = () => {
//     setOpenDropdownIndex(null);
//   };

//   const viewProfile = () => {
//     navigate(`/userlist/${195}`);
//   };

//   const getUserRole = () => {
//     const data = JSON.parse(localStorage.getItem("data"));
//     return data ? data.details.userRole.role_id : null;
//   };

//   const filterSidebarData = (role) => {
//     const filterSubMenu = (item, allowedSubMenus) => {
//       if (item.subNav && item.subNav.length > 0) {
//         item.subNav = item.subNav.filter((subItem) =>
          
//           allowedSubMenus.includes(subItem.title),
          
//         );
        
//       }
//       return item;
//     };
  
//     if (role === 1) {
//       return SidebarData; 
//     } else if (role === 4) {
//       return SidebarData.filter((item) =>
//         ["Dashboard","Configuration" ].includes(item.title)
//       ).map((item) => filterSubMenu(item, ["Orders", "Brand Categorization"])); 
//     } else if (role === 11) {
//       return SidebarData.filter((item) =>
//         ["Dashboard", "Configuration"].includes(item.title)
//       ).map((item) => filterSubMenu(item, ["Submenu3"]));
//     } else if (role === 2) {
//       return SidebarData.filter((item) =>
//         ["Dashboard", "Add Center", "Wallets and Tags"].includes(item.title)
//       ).map((item) => filterSubMenu(item, ["Submenu4", "Submenu5"]));
//     } else if (role === 3) {
//       return SidebarData.filter((item) =>
//         ["Dashboard", "Customer Manager", "Configuration"].includes(item.title)
//       ).map((item) => filterSubMenu(item, ["Reports and Analytics","Orders", "Brand Categorization",]));
//     } else if (role === 5) {
//       return SidebarData.filter((item) =>
//         ["Dashboard", "Configuration", "Add Center"].includes(item.title)
//       ).map((item) => filterSubMenu(item, ["Submenu8"]));
//     } else if (role === 6) {
//       return SidebarData.filter((item) =>
//         ["Configuration","Users and Roles" ].includes(item.title)
//       ).map((item) => filterSubMenu(item, ["Vending machines", "Cohorts","Manage Partners"]));
//     }   else if (role === 7) {
//       return SidebarData.filter((item) =>
//         ["Configuration"].includes(item.title)
//       ).map((item) => filterSubMenu(item, ["Submenu9", "Submenu10"]));
//     }
  
   
//     return [];
//   };
  


//   // const filterSidebarData = (role) => {
//   //   switch (role) {
//   //     case 1:
//   //       return SidebarData;
//   //     case 2:
//   //       return SidebarData.filter((item) =>
//   //         ["Dashboard", "Add Center", "Wallets and Tags"].includes(item.title)
//   //       );
//   //     case 3:
//   //       return SidebarData.filter((item) =>
//   //         ["Dashboard", "Customer Manager", "Configuration"].includes(
//   //           item.title
//   //         )
//   //       );
//   //     case 4:
//   //       return SidebarData.filter((item) =>
//   //         ["Dashboard", "Users and Roles"].includes(item.title)
//   //       );
//   //     case 5:
//   //       return SidebarData.filter((item) =>
//   //         ["Dashboard", "Configuration", "Add Center"].includes(item.title)
//   //       );
//   //     case 6:
//   //       return SidebarData.filter((item) =>
//   //         ["Dashboard", "Customer Manager", "Wallets and Tags"].includes(
//   //           item.title
//   //         )
//   //       );
      
//   //     default:
//   //       return [];
//   //   }
//   // };


//   const userRole = getUserRole();
//   const filteredSidebarData = filterSidebarData(userRole);

//   return (
//     <>
//       <div className="side-div1">
//         <div className="sidebar">
//           <div className="">
//             <div className="logo-div">
//               <img src={logo} alt="" />
//             </div>
//             <div className="main-profile">
//               <div className="profileDiv">
//                 <img src={Avtar} alt="" />
//                 {localStorage.data && (
//                   <div className="designation">
//                     <p style={{ textTransform: "capitalize" }}>
//                       {
//                         JSON.parse(localStorage.data).details.userDetails
//                           .full_name
//                       }
//                     </p>
//                     <span>
//                       {JSON.parse(localStorage.data).details.userRole.role_name}
//                     </span>
//                   </div>
//                 )}
//               </div>
//               <div className="view-profile">
//                 <Link
//                   to={`/users/userlist/${
//                     localStorage.data
//                       ? JSON.parse(localStorage.data).details.userDetails.id
//                       : "N/A"
//                   }`}
//                 >
//                   <div
//                   style={{ border: "0.1px solid #ccc", marginTop: "30px", }}
//                   >
//                     <button className="viewBtn">View Profile</button>
//                   </div>
//                 </Link>
//               </div>
//             </div>
//           </div>

//           <div >
//             {filteredSidebarData.map((item) => (
//               <SubMenu
//                 key={item.title}
//                 item={item}
//                 openDropdownIndex={openDropdownIndex}
//                 setOpenDropdownIndex={setOpenDropdownIndex}
//                 handleCloseDropdown={handleCloseDropdown}
//               />
//             ))}
//           </div>
//         </div>
//         <div>
//           <div className="logoutOutter">
//             <Button
//               style={{
//                 padding: "1vh 3vw",
//                 backgroundColor: "#fff",
//                 fontSize: "1vw",
//                 color: "black",
//               }}
//               variant="outline-danger"
//               size="lg"
//               onClick={() => setShow(true)}
//             >
//               Logout
//             </Button>
//           </div>
//         </div>

//         <Modal
//           className="logout-main"
//           show={show}
//           onHide={() => setShow(false)}
//         >
//           <div className="child-div">
//             <div className="child-1">
//               <img className="img-avtar" src={avtar2} alt="" />
//             </div>

//             <div className="child-2">
//               <p>Log Out</p>
//               <span>Are you sure want to Log Out ?</span>
//             </div>
//             <div className="logout-btn">
//               <Button className="cancelBtn" onClick={handleClose}>
//                 Cancel
//               </Button>
//               <Button className="logoutBtn1" onClick={logout}>
//                 Yes, Logout
//               </Button>
//             </div>
//           </div>
//         </Modal>
//       </div>
//     </>
//   );
// }


import React, { useState, useEffect } from "react";
import styles from "./Sidebar.module.css";
import { FaBars, FaTimes } from "react-icons/fa";
import Modal from "@mui/material/Modal";
import avtar2 from "../../../assests/emotions2.svg";
import { useNavigate } from "react-router-dom";
import logo from "../../../assests/Daalchini-logo.svg";
import Avtar from "../../../assests/Avatar.png";
import { Link } from "react-router-dom";
import SubMenu from "../Sidebar/SidebarItem";
import { SidebarData } from "./SidebarData";
import { useParams } from "react-router-dom";

export default function Sidebar() {
  const navigate = useNavigate();
  const { userid } = useParams();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  // Check if mobile view
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const logout = () => {
    localStorage.removeItem("allPermissions");
    localStorage.removeItem("data");
    window.location.href = "/";
  };

  const handleCloseDropdown = () => {
    setOpenDropdownIndex(null);
  };

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
    if (isMobile) {
      setIsOpen(false);
    }
  };

  const closeLogoutModal = () => {
    setShowLogoutModal(false);
  };

  
  const sidebarClasses = [
    styles.sidebar,
    isMobile ? styles.sidebarMobile : '',
    isMobile && isOpen ? styles.sidebarMobileOpen : ''
  ].filter(Boolean).join(' ');

  const getUserRole = () => {
    const data = JSON.parse(localStorage.getItem("data"));
     return data ? data.details.userRole.role_id : null;
   };

   const permissions = JSON.parse(localStorage.getItem("userPermissions")) || [];
const filterSidebarData = (data, userPermissions) => {
  return data
    .map(item => {
      const filteredSubNav = item.subNav
        ? item.subNav.filter(sub =>
            !sub.permissions || sub.permissions.some(p => userPermissions.includes(p))
          )
        : [];

      if (
        !item.permissions ||
        item.permissions.some(p => userPermissions.includes(p)) ||
        filteredSubNav.length > 0
      ) {
        return { ...item, subNav: filteredSubNav };
      }
      return null;
    })
    .filter(Boolean);
};



const filteredSidebarData = filterSidebarData(SidebarData, permissions);


const userRole = getUserRole();


  return (
    <>
      {/* Mobile Hamburger Button */}
      {isMobile && (
        <button 
          className={styles.hamburgerButton} 
          onClick={toggleMenu} 
          aria-label={isOpen ? "Close menu" : "Open menu"}
        >
          {isOpen ? (
            <FaTimes className={styles.hamburgerIcon} />
          ) : (
            <FaBars className={styles.hamburgerIcon} />
          )}
        </button>
      )}

      <div className={sidebarClasses}>
        <div className={styles.sidebarContent}>
          <div className={styles.logoContainer}>
            <img src={logo} alt="Daalchini Logo" className={styles.logoImg} />
          </div>

        <div className={styles.profileContainer}>
  <div className={styles.profileRow}>
    <img src={Avtar} alt="User Avatar" className={styles.profileImage} />
    <div className={styles.profileInfo}>
      <p className={styles.userName}>
        {JSON.parse(localStorage.data).details.userDetails.full_name}
      </p>
      <span className={styles.userRole}>
        {JSON.parse(localStorage.data).details.userRole.role_name}
      </span>
    </div>
  </div>

  {/* Only show the button if user has "user_dash_view" permission */}
  {permissions.includes("user_dash_view") && (
    <button
      className={styles.viewProfileButton}
      onClick={() => {
        const userId = localStorage.data
          ? JSON.parse(localStorage.data).details.userDetails.id
          : "N/A";
        navigate(`/users/userlist/${userId}`);
      }}
    >
      View Profile
    </button>
  )}
</div>


          {/* <div className={styles.menuContainer}>
            {SidebarData.map((item) => (
              <SubMenu
                key={item.title}
                item={item}
                openDropdownIndex={openDropdownIndex}
                setOpenDropdownIndex={setOpenDropdownIndex}
                handleCloseDropdown={handleCloseDropdown}
              />
            ))}
          </div> */}
          {/* <div className={styles.menuContainer}>
  {filteredSidebarData.map((item) => (
    <SubMenu
      key={item.title}
      item={item}
      openDropdownIndex={openDropdownIndex}
      setOpenDropdownIndex={setOpenDropdownIndex}
      handleCloseDropdown={handleCloseDropdown}
    />
  ))}
</div> */}

          <div >
            {filteredSidebarData.map((item) => (
              <SubMenu
                key={item.title}
                item={item}
                openDropdownIndex={openDropdownIndex}
                setOpenDropdownIndex={setOpenDropdownIndex}
                handleCloseDropdown={handleCloseDropdown}
              />
            ))}
          </div>

          <button className={styles.logoutButton} onClick={handleLogoutClick}>
            Logout
          </button>
        </div>
      </div>
      
      {/* Overlay for mobile when menu is open (hidden when modal is open) */}
      {isMobile && isOpen && !showLogoutModal && (
        <div className={styles.overlay} onClick={toggleMenu} />
      )}

      {/* MUI Logout Modal */}
      <Modal
        open={showLogoutModal}
        onClose={closeLogoutModal}
        className={styles.modalContainer}
      >
        <div className={styles.modalPaper}>
          <div className={styles.modalHeader}>
            <img src={avtar2} alt="Logout Illustration" className={styles.modalImage} />
          </div>
          <div className={styles.modalBody}>
            <h5 className={styles.modalTitle}>Log Out</h5>
            <p className={styles.modalMessage}>Are you sure you want to log out?</p>
          </div>
          <div className={styles.modalFooter}>
            <button className={styles.cancelButton} onClick={closeLogoutModal}>
              Cancel
            </button>
            <button className={styles.confirmButton} onClick={logout}>
              Yes, Logout
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}